import React from 'react';

import {
    RadioGroup,
    RadioGroupProps,
} from 'reactApp/components/RadioGroup/RadioGroup';

import { BasicField } from './_BasicField';

type Props = Omit<RadioGroupProps, 'className'> & {
    fieldClassName?: string;
    label?: string;
    type?: string;
    extraLabel?: string | React.ReactNode;
    setTouchedOnChange?: boolean;
};
export const FieldRadioGroup = ({
    label = ' ', // important for field styles
    name,
    options,
    fieldClassName,
    onChange: _onChange,
    ...otherProps
}: Props) => (
    <BasicField
        {...{
            label,
            name,
            options,
            fieldClassName,
            onChange(...args) {
                if (typeof _onChange === 'function') {
                    Promise.resolve().then(() => {
                        _onChange(...args); // TODO: make it sync!
                    });
                }
            },
            control: RadioGroup,
            ...otherProps,
        }}
    />
);

FieldRadioGroup.enumToRadioOptions = function<T>(enumParam: T) {
    return FieldRadioGroup.mapOptions(Object.values(enumParam));
};

FieldRadioGroup.mapOptions = function<T>(arr: T[], key?: string) {
    return arr.map((item) => {
        const val = key ? item[key] : item;
        return {
            value: val,
            label: val,
        };
    });
};
